import { render, staticRenderFns } from "./AdminCasinoGames.vue?vue&type=template&id=1de83879&"
import script from "./AdminCasinoGames.vue?vue&type=script&lang=js&"
export * from "./AdminCasinoGames.vue?vue&type=script&lang=js&"
import style0 from "./AdminCasinoGames.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports